export enum EStrategyStatus {
    Ordered = 100,
    New = 1,
    WorkMeasurementMPCA = 2,
    ZoneProcess = 3,
    Proposal = 4,
    WorkInProgress = 7,
    FinalReportTBD = 5,
    FinalReport = 6,
}
